import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CreateAssignmentForm from "./delivery-form";
import useReactHookForm from "hooks/useReactHookForm";
import buildTestServices from "pages/build-test/service";
import { useState } from "react";
import { makeStyles } from "@mui/styles";
import { useLocation, useHistory, useRouteMatch } from "react-router";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { ResponseGenerator } from "interfaces";
import { devliveryByIdRequest } from "pages/build-test/slices/get-delivery-by-id";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";

import {
  createDeliveryTestTitle,
  createDeliveryValidationSchema,
  mandatoryFields,
} from "pages/build-test/routes/delivery/helpers";
import LibraryService from "pages/build-test/service";
import { refreshDeliveryRequest } from "pages/build-test/slices/refresh-delivery-request";
import { useLazyQuery } from "@apollo/client";
import { GET_EXAM_SCHEDULE_ID } from "utils/graphql/services/exam-schedule/queries";
import myClassroomClient from "utils/graphql/myclassroom";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { isEmpty } from "utils/helpers";
import { createBuildTestProperties, deliveryListMetakey, getSelectedStates, getSelectedYear ,
  createDeliveryInitialValues,
  createDeliveryProperties,
} from "./helper";

const useStyles = makeStyles({
  padding: {
    "& .css-1oqqzyl-MuiContainer-root ": {
      padding: 0,
    },
  },
});

export default function UpdateDelivery() {
  const classes = useStyles();
  const search = useLocation().search;
  const match: any = useRouteMatch();
  let deliveryId = match?.params?.deliveryId;
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [validateDelivery, setValidDelivery] = useState(false);
  const [isSchedulePassed, setIsSchedulePassed] = useState(false);
  const [propertiesMismatch, setPropertiesMismatch] = useState(false);

  // Helper function to check if delivery time has passed
  const isDeliveryTimePassed = (startDateTime: string) => {
    if (!startDateTime) return false;

    const now = new Date();
    // Parse datetime string format: "2026-01-22 15:00:00"
    const deliveryDate = new Date(startDateTime.replace(' ', 'T'));

    return now > deliveryDate;
  };

  // Helper function to compare arrays (order-independent)
  const arraysMatch = (arr1: any[], arr2: any[]) => {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    const sorted1 = [...arr1].sort();
    const sorted2 = [...arr2].sort();
    return sorted1.every((val, index) => val === sorted2[index]);
  };

  // Function to compare schedule and delivery properties
  const checkPropertiesMatch = (scheduleData: any, deliveryData: any) => {
    if (!scheduleData || !deliveryData) return true; // Return true (no mismatch) if data is missing

    const academicYearMatch = arraysMatch(
      scheduleData.academic_year_ids,
      deliveryData.academic_year_list
    );
    const stateMatch = arraysMatch(
      scheduleData.state_ids,
      deliveryData.state_list
    );
    const collegeMatch = arraysMatch(
      scheduleData.college_ids,
      deliveryData.college_list
    );
    const boardMatch = arraysMatch(
      scheduleData.board_ids,
      deliveryData.board_list
    );
    const classMatch = arraysMatch(
      scheduleData.class_ids,
      deliveryData.class_list
    );
    const batchMatch = arraysMatch(
      scheduleData.batch_ids,
      deliveryData.batch_list
    );

    // Return true if all match, false if any mismatch
    return academicYearMatch && stateMatch && collegeMatch && boardMatch && classMatch && batchMatch;
  };
  const { data } = useAppSelector((state) => state.getBuildTestDeliveryById);
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    createDeliveryInitialValues,
    createDeliveryValidationSchema,
    ""
  );
  const deliveryData: any = data;
  const { validateData, error, loading } = useAppSelector(
    (state) => state.validateWarmUp
  );

  const { refreshdata, refresherror, isLoadingrefresh } = useAppSelector(
    (state) => state.refreshDeliveryReducer
  );

  const hasDeliveryData: boolean =
    (deliveryData && deliveryData[0]) !== undefined;
  const history = useHistory();

  const { isLoading:isLoadingMeta, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

  const [getExamById, { loading: loadingUp, error: errorUp, data: dataSch }] =
    useLazyQuery(GET_EXAM_SCHEDULE_ID, {
      client: myClassroomClient,
    });

  const updateMetaData = async (listData, metaKey, listData2, metaKey2) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    await dispatch(metadataSuccess(metadataList));
  };

  useEffect(() => {
    const reqBody: any = { delivery_id: deliveryId };
    dispatch(devliveryByIdRequest(reqBody)); ///--------------------------------->
  }, []);

  useEffect(() => {
    if (
      !loading &&
      watch().warm_up_delivery_id !== "" &&
      watch().warm_up_delivery_id != null
    ) {
      const res: any = LibraryService.getValidateWarmUp({
        delivery_id: deliveryData[0].delivery_id,
        warm_up_delivery_id: watch().warm_up_delivery_id,
      });

      res.then((response) => {
        if (response.data.data.is_valid_delivery) {
          setValidDelivery(response.data.data.is_valid_delivery);
          dispatch(snackbarRequest({ message: "Warm Up Id is valid" }));
        } else {
          setValidDelivery(response.data.data.is_valid_delivery);
          dispatch(
            snackbarRequest({ message: response.data.message, type: "error" })
          );
        }
      });
    } else {
      setValidDelivery(true);
    }
    // deliveryId = "";//--------------------------------------->
  }, [watch().warm_up_delivery_id]);

  useEffect(() => {
    if (deliveryId && hasDeliveryData) {
      setValue("test_name", deliveryData[0].test_name);
      setValue("test_id", deliveryData[0].test_id);
      setValue("label", deliveryData[0].label);
      setValue("warm_up_delivery_id", deliveryData[0].warm_up_delivery_id);
      setValue("start_date_time", deliveryData[0].start_date_time);
      setValue("end_date_time", deliveryData[0].end_date_time);

      // Check if the delivery time has passed
      const timePassed = isDeliveryTimePassed(deliveryData[0].start_date_time);
      setIsSchedulePassed(timePassed);
      setValue(
        "is_jumble",
        deliveryData[0].is_jumble ? "k2UYArvtfr" : "Lf37ipufz5"
      );
      setValue("attendance", deliveryData[0].attendance);
      setValue("academic_year_id", deliveryData[0].academic_year_list);
      setValue(
        "reservation_status_id",
        deliveryData[0].reservation_status_list
      );
      setValue("class_id", deliveryData[0].class_list);
      setValue("batch_id", deliveryData[0].batch_list);
      setValue("sub_batch_id", deliveryData[0].sub_batch_list);
      setValue("state_id", deliveryData[0].state_list);
      setValue("district_object_id", deliveryData[0].district_list);
      setValue("college_id", deliveryData[0].college_list);
      setValue("board_id", deliveryData[0].board_list);
      setValue("ntse_exam_object_id", deliveryData[0].ntse_exam_object_id);
      setValue("cnaps_level_list", deliveryData[0].cnaps_level_list);
      setValue(
        "delivery_type_object_id",
        deliveryData[0].delivery_type_object_id
      );
      setValue("test_type", deliveryData[0]?.exam_category_name);
      setValue(
        "show_results",
        deliveryData[0]?.show_results == true ? "true" : "false"
      );
      setValue(
        "show_response_sheet",
        deliveryData[0]?.show_response_sheet == true ? "true" : "false"
      );
      setValue(
        "show_revise_now",
        deliveryData[0]?.show_revise_now == true ? "true" : "false"
      );
    }
  }, [deliveryData, dispatch]);

  const handleDeliveryRefresh = () => {
    const reqObj: any = {
      delivery_id: match?.params?.deliveryId,
    };
    dispatch(refreshDeliveryRequest(reqObj));
  };

  const handleSubmit = async () => {
    const values = watch();
    const {
      test_id,
      label,
      is_jumble,
      attendance,
      academic_year_id,
      state_id,
      district_object_id,
      college_id,
      reservation_status_id,
      class_id,
      batch_id,
      sub_batch_id,
      start_date_time,
      end_date_time,
      delivery_type_object_id,
      board_id,
      ntse_exam_object_id,
      cnaps_level_list,
      warm_up_delivery_id,
      show_results,
      show_response_sheet,
      show_revise_now,
    } = values;

    const reqBody: any = {
      test_id: test_id,
      label: label,
      schedule_exam_delivery_id: match?.params?.schdule_id,
      jumble_status_object_id: is_jumble,
      attendance_object_id: attendance,
      academic_year_list: academic_year_id,
      state_list: state_id,
      district_list: district_object_id,
      college_list: college_id,
      reservation_status_list: reservation_status_id,
      class_list: class_id,
      batch_list: batch_id,
      sub_batch_list: sub_batch_id,
      start_date_time: start_date_time,
      end_date_time: end_date_time,
      delivery_type_object_id: delivery_type_object_id,
      board_list: board_id,
      ntse_exam_object_id: ntse_exam_object_id,
      cnaps_level_list: cnaps_level_list,
      warm_up_delivery_id: warm_up_delivery_id,
      show_results: show_results == "true" ? true : false,
      show_response_sheet: show_response_sheet == "true" ? true : false,
      show_revise_now: show_revise_now == "true" ? true : false,
    };
    const updateBody: any = {
      ...reqBody,
      test_uri: deliveryData[0].test_uri,
      delivery_id: deliveryData[0].delivery_id,
      uri: deliveryData[0].delivery_uri,
    };

    if (validateDelivery) {
      setIsLoading(true);
      const res: ResponseGenerator =
        await buildTestServices.updateBuildDeliveryApi(updateBody);
      if (res.status === 200 && res.data.status === "success") {
        setIsLoading(false);
        dispatch(snackbarRequest({ message: res?.data?.message }));
      } else {
        setIsLoading(false);
        dispatch(snackbarRequest({ message: res.data.message, type: "error" }));
      }
      history.replace(
        `/exam_schedule/delivery_list/${match?.params?.schdule_id}`
      );
    } else {
      dispatch(
        snackbarRequest({
          message: "Please enter valid Warm up id",
          type: "error",
        })
      );
    }
  };

  useEffect(() => {
    getExamById({
      variables: {
        id: match?.params?.schdule_id,
      },
    });
  }, []);

    useEffect(() => {
      if (!isEmpty(dataSch?.getExamSchedule)) {
        const { getExamSchedule } = dataSch;
  
        updateMetaData(
          metaData?.state_list,
          deliveryListMetakey?.state,
           metaData?.academic_year_list,
          deliveryListMetakey?.year
        );

        // Check if schedule and delivery properties match
        if (deliveryData && deliveryData[0]) {
          const isMatch = checkPropertiesMatch(getExamSchedule, deliveryData[0]);
          setPropertiesMismatch(!isMatch); // Set to true if there's a mismatch
        }
      }
    }, [dataSch, deliveryData]);

    if(loadingUp){
      return <p> loading...</p>
    }
    
  return (
    <>
    <Box sx={{ width: "100%" }} className={classes.padding}>
      {propertiesMismatch && (
        <Box sx={{ mb: 2 }}>
          <Typography 
            sx={{ 
              backgroundColor: '#fff3cd', 
              color: '#856404', 
              padding: '12px 16px', 
              borderRadius: '4px',
              border: '1px solid #ffeaa7',
              fontWeight: 500
            }}
          >
            ⚠️ Warning: Schedule and delivery properties don't match. Please verify.
          </Typography>
        </Box>
      )}
      <CreateAssignmentForm
        control={control}
        errors={errors}
        getValues={getValues}
        setValue={setValue}
        watch={watch}
        headerFields={createDeliveryTestTitle}
        mainFields={createDeliveryProperties(
          deliveryData[0]?.exam_category_name
        )}
        detailsFields={createBuildTestProperties}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
        title={"Edit Delivery"}
        buttonValue={"Update Delivery"}
        handleRefresh={handleDeliveryRefresh}
        mandatoryFields={mandatoryFields(deliveryData[0]?.exam_category_name)}
        dataSch={dataSch}
        isSchedulePassed={isSchedulePassed}
        isUpdate={true}
      />
    </Box>
    </>
  );
}
